export default Object.freeze({
    NotStarted : 'NotStarted',
    Draft : 'draft',
    Running : 'running',
    Queued : 'queued',
    Completed : 'completed',
})
